import { H5 } from 'UIComponents/elements/headings';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIPanelSection from 'UIComponents/panel/UIPanelSection';
import UILink from 'UIComponents/link/UILink';
import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import ListSelect from 'automation-ui-enrollment/components/enrollment/manual/ListSelect';
import { listPageUrlFromId } from 'automation-ui-enrollment/constants/urls';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ManualEnrollmentByList = ({
  objectTypeId,
  selectedListId,
  handleListSelect,
  mode
}) => {
  return /*#__PURE__*/_jsxs(UIPanelSection, {
    className: "m-top-10 p-top-0",
    children: [/*#__PURE__*/_jsx(H5, {
      className: "m-bottom-2",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-enrollment.redesign.enrollExistingPanel.enrollFromList.selected.title"
      })
    }), mode === 'EXISTING' ? /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
      baseLangKey: "automation-ui-enrollment.redesign.enrollExistingPanel.enrollFromList.informationExisting_cob",
      objectTypeId: objectTypeId
    }) : /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
      baseLangKey: "automation-ui-enrollment.redesign.enrollExistingPanel.selected.information_cob",
      objectTypeId: objectTypeId
    }), /*#__PURE__*/_jsx(ListSelect, {
      selectedListId: selectedListId,
      onListSelect: selectedListEvent => {
        handleListSelect(selectedListEvent.target.value);
      },
      objectTypeId: objectTypeId
    }), selectedListId && /*#__PURE__*/_jsx(View, {
      marginBlockStart: "200",
      as: "div",
      children: /*#__PURE__*/_jsx(UILink, {
        external: true,
        href: listPageUrlFromId(selectedListId),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.redesign.enrollExistingPanel.enrollFromList.selected.viewLink"
        })
      })
    })]
  });
};
export default ManualEnrollmentByList;